import React from "react";
import {
    Select,
    SelectValue,
    SelectTrigger,
    SelectContent,
    SelectItem,
} from "@/components/ui/select";
import { SortOptions } from "@/lib/utils";

interface UnitTableSortProps {
    selectedSort: string;
    setSelectedSort: React.Dispatch<React.SetStateAction<string>>;
}

type SortOption = {
    value: SortOptions;
    label: string;
};

const sortOptions: SortOption[] = [
    { value: SortOptions.VACANCY_ASCENDING, label: "Availability: Low - High" },
    {
        value: SortOptions.VACANCY_DESCENDING,
        label: "Availability: High - Low",
    },
    { value: SortOptions.PRICE_ASCENDING, label: "Price: Low - High" },
    { value: SortOptions.PRICE_DESCENDING, label: "Price: High - Low" },
    { value: SortOptions.AREA_ASCENDING, label: "Size: Small - Large" },
    { value: SortOptions.AREA_DESCENDING, label: "Size: Large - Small" },
];

export const UnitTableSort = ({
    selectedSort,
    setSelectedSort,
}: UnitTableSortProps) => {
    return (
        <Select
            value={selectedSort}
            onValueChange={(value) => setSelectedSort(value)}
        >
            <SelectTrigger>
                <SelectValue placeholder="Sort By" />
            </SelectTrigger>
            <SelectContent className="se-vapor se-vapor-sort">
                {sortOptions.map(({ value, label }) => (
                    <SelectItem value={value} key={value}>
                        {label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};
